import React from 'react';
import { Button } from '@mui/material';
import { ButtonProps } from '@mui/material/Button/Button';

const ButtonComponent: React.FC<ButtonProps> = ({ children, ...rest }) => (
  <Button
    variant="contained"
    // disabled={disabled}
    {...rest}
  >
    {children}
  </Button>
);

export default ButtonComponent;
